import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { UserService } from '@core/services/oauth-service/user.service';
import { WelcomeService } from '@core/services/welcome/welcome.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CallbackComponent implements OnInit, OnDestroy {
  private readonly destroying$ = new Subject<void>();

  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private msalAuthService: MsalService,
    private userService: UserService,
    private router: Router,
    readonly welcomeService: WelcomeService
  ) {}

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this.destroying$)
      )
      .subscribe({
        next: () => {
          console.log(
            '[CallbackComponent] Authentication completed => performing post-login setup'
          );
          this.checkAndSetActiveAccount();
          this.navigateAfterLogin();
        },
      });
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     */
    const activeAccount = this.msalAuthService.instance.getActiveAccount();

    if (!activeAccount) {
      
      const accounts = this.msalAuthService.instance.getAllAccounts();
      if (accounts.length > 0) {
        this.msalAuthService.instance.setActiveAccount(accounts[0]);
        this.userService.setLoginDisplay();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }

  navigateAfterLogin() {
    const previousUrl = localStorage.getItem('previousUrl');

    // Navigate to previousUrl if it exists and is not the callback page, otherwise go to dashboard
    if (
      previousUrl &&
      !previousUrl.includes('/authentication/callback')
    ) {
      console.log('[CallbackComponent] Navigating to previous URL:', previousUrl);
      this.router.navigateByUrl(previousUrl);
      this.welcomeService.openWelcomePopUpModal();
    } else {
      console.log('[CallbackComponent] Navigating to dashboard');
      this.router.navigate(['/dashboard']);
    }
  }
}
